import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export const sendMessageToDb = createAsyncThunk('dialogs/sendMessage', async (text, { rejectWithValue }) => {
  try {
    await addDoc(collection(db, 'messages'), {
      text: text,
      sender: 'me',
      createdAt: serverTimestamp(),
    });
    return true;
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

const initialState = {
  dialogs: [
    { id: 1, name: 'Анна', lastMessage: 'Привет!' },
    { id: 2, name: 'Иван', lastMessage: 'Как дела?' },
  ],
  messages: [],
  newMessageText: '',
};

const dialogsSlice = createSlice({
  name: 'dialogs',
  initialState,
  reducers: {
    updateNewMessageText: (state, action) => {
      state.newMessageText = action.payload;
    },
    setMessages: (state, action) => {
      state.messages = Array.isArray(action.payload) ? action.payload : [];
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendMessageToDb.fulfilled, (state) => {
      state.newMessageText = '';
    });
  },
});

export const { updateNewMessageText, setMessages } = dialogsSlice.actions;
export default dialogsSlice.reducer;